export default {"src":"/_next/static/media/trophy.8ef46060.gif","height":512,"width":512,"blurWidth":0,"blurHeight":0};